export enum AnimationType {
  FadeInUp = "fadeInUp",
  FadeInLeft = "fadeInLeft",
  FadeInRight = "fadeInRight",
}

export enum RouteIdEnum {
  Root = "/",
  Any = "*",
  ProjectDetails = "/project-details/:id",
  Home = "/home",
  Projects = "/projects",
  About = "/about",
  Contact = "/contact",
}
